import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Dimens from 'src/core/utils/Dimens';
import Constants from 'src/core/utils/Constants';
import Styles from 'src/core/utils/Styles';

const HEADER_CONTENT_HEIGHT = Dimens.size70;

const headerShadow = {
	...Styles.header.shadow,
	borderBottomWidth: Dimens.borderWidth0,
};

export const useHeaderStyle = () => {
	const insets = useSafeAreaInsets();

	return {
		...headerShadow,
		height: Platform.OS === Constants.platformWeb ? HEADER_CONTENT_HEIGHT : insets.top + HEADER_CONTENT_HEIGHT,
	};
};

export const useModalHeaderStyle = () => {
	const insets = useSafeAreaInsets();

	if (Platform.OS === Constants.platformAndroid) {
		return { ...headerShadow, height: insets.top + HEADER_CONTENT_HEIGHT };
	}

	return { ...headerShadow, height: HEADER_CONTENT_HEIGHT };
};
